import React, { createContext, useContext, useState, useEffect } from 'react';

interface InitialLoadingContextType {
  isInitialLoading: boolean;
  setInitialLoading: (loading: boolean) => void;
  hasVisitedHome: boolean;
  setHasVisitedHome: (visited: boolean) => void;
}

const InitialLoadingContext = createContext<InitialLoadingContextType | undefined>(undefined);

export const InitialLoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isInitialLoading, setInitialLoading] = useState(true);
  const [hasVisitedHome, setHasVisitedHome] = useState(false);

  // Set initial loading to false after a minimum display time
  useEffect(() => {
    // Only start the timer if we're in initial loading state
    if (isInitialLoading) {
      const timer = setTimeout(() => {
        setInitialLoading(false);
        setHasVisitedHome(true);
      }, 3000); // Minimum 2 seconds display time

      return () => {
        clearTimeout(timer);
      };
    }
  }, [isInitialLoading]);

  return (
    <InitialLoadingContext.Provider 
      value={{ 
        isInitialLoading, 
        setInitialLoading,
        hasVisitedHome,
        setHasVisitedHome
      }}
    >
      {children}
    </InitialLoadingContext.Provider>
  );
};

export const useInitialLoading = () => {
  const context = useContext(InitialLoadingContext);
  if (context === undefined) {
    throw new Error('useInitialLoading must be used within an InitialLoadingProvider');
  }
  return context;
}; 